module.exports = __webpack_public_path__ + "img/acabado_fino_con_estuco.9449327b.png";